'use client';
import { useSearchParams } from 'next/navigation';

// You can centralize option keys here.
export const DEFAULT_OPTION_KEYS = ['size', 'color', 'denominations'];

export function useActiveOptions(optionKeys: string[] = DEFAULT_OPTION_KEYS): Record<string, string | null> {
  const searchParams = useSearchParams();
  const activeOptions: Record<string, string | null> = {};
  optionKeys.forEach((key) => {
    activeOptions[key] = searchParams.get(key);
  });
  return activeOptions;
}
